<form [formGroup]="emailForm" (ngSubmit)="saveEmailDialogSubmit()">
  <!--Radio Buttons-->
  <div class="radio-group" [formGroup]="emailForm">
    <label *ngFor="let option of emailOptions">
      <p-radioButton
        type="radio"
        name="emailType"
        [value]="option.number"
        formControlName="emailType"
      />
      {{ option.label }}
    </label>
  </div>

  <div class="form-group">
    <p-editor formControlName="text" />
  </div>

  <!-- Felder Parsen -->
  <div class="dialog-buttons">
    <button
      pButton
      type="button"
      label="Informationen übertragen"
      (click)="parseEmailText()"
    ></button>
    <!--Hilfe Butoon-->
    <button
      class="icon-only-button"
      pButton
      type="button"
      icon="pi pi-question-circle"
      class="icon-only-button"
      (click)="openHelpDialog()"
    ></button>
  </div>

  <!-- Dialog mit Beispieltext -->
  <p-dialog
    header="Beispiel für die Email"
    [(visible)]="displayHelpDialog"
    [modal]="true"
    [closable]="true"
    [style]="{ width: '30vw' }"
    appendTo="body"
  >
    <p>Bitte kopiere den Text einer Email im folgenden Format:</p>
    <pre>{{ helpText }}</pre>
  </p-dialog>

  <!-- Intressent/Teilnehmer -->
  <div class="form-group">
    <p-floatLabel variant="in">
      <p-dropdown
        [options]="availableUsers"
        [loading]="usersLoading"
        name="participantId"
        optionLabel="fullName"
        optionValue="userId"
        [showClear]="true"
        formControlName="participantId"
        [filter]="true"
        filterBy="fullName"
      >
      </p-dropdown>
      <label>Interessent/Teilnehmer:in</label>
    </p-floatLabel>
  </div>

  <!-- Absender -->
  <div class="form-group">
    <p-floatLabel>
      <input pInputText id="sender" type="text" formControlName="sender" />
      <label for="sender">Absender:in</label>
    </p-floatLabel>
  </div>

  <!-- Empfänger -->
  <div class="form-group">
    <p-floatLabel>
      <input
        pInputText
        id="recipient"
        type="text"
        formControlName="recipient"
      />
      <label for="recipient">Empfänger:in</label>
    </p-floatLabel>
  </div>

  <!-- Absender Dropdown
<div class="form-group">
  <p-floatLabel variant="in">
    <p-dropdown
      [options]="availableUsers"
      [loading]="usersLoading"
      name="senderId"
      optionLabel="fullName"
      optionValue="fullName"
      [showClear]="true"
      formControlName="senderId"
      [filter]="true"
      filterBy="fullName"
    >
    </p-dropdown>
    <label>Absender:in</label>
  </p-floatLabel>
</div> -->

  <!-- Gesendet Datum -->
  <div class="form-group">
    <p-floatLabel variant="in">
      <p-calendar
        inputId="sentAt"
        formControlName="sentAt"
        name="sentAt"
        dateFormat="dd.mm.yy"
        showIcon="true"
        [showTime]="true"
        hourFormat="24"
        appendTo="body"
      ></p-calendar>
      <label for="sentAt">Gesendet</label>
    </p-floatLabel>
  </div>

  <!-- Empfänger Dropdown
<div class="form-group">
  <p-floatLabel variant="in">
    <p-dropdown
      [options]="availableUsers"
      [loading]="usersLoading"
      name="recipientId"
      optionLabel="fullName"
      optionValue="fullName"
      [showClear]="true"
      formControlName="recipientId"
      [filter]="true"
      filterBy="fullName"
    >
    </p-dropdown>
    <label>Empfänger:in</label>
  </p-floatLabel>
</div> -->

  <!-- Betreff -->
  <div class="p-field">
    <p-floatLabel>
      <input pInputText id="subject" type="text" formControlName="subject" />
      <label for="subject">Betreff</label>
    </p-floatLabel>
  </div>

  <div class="form-buttons">
    <button
      pButton
      [loading]="isSubmitting"
      label=""
      title="Speichern"
      icon="pi pi-save"
      type="submit"
      class="p-button-success"
      [disabled]="!emailForm.valid"
    ></button>
    <button
      pButton
      [loading]="isSubmitting"
      title="Abbrechen"
      type="button"
      label="Abbrechen"
      class="p-button-secondary"
      icon="pi pi-times"
      (click)="closeDialog()"
    ></button>
  </div>
</form>
